import { getSessionLsItem } from '~/App/Auth/utils/authLs'
import type { Request } from '~/utils/BaseApi'
import { BaseApi } from '~/utils/BaseApi'

export { BadRequestApiError, NotFoundApiError, UnauthorizedApiError } from '~/utils/BaseApi'

const DEFAULT_HEADERS = {
  'Content-Type': 'application/vnd.api+json',
  'Ccn-App': 'WEB_FLOW',
}

export class Api extends BaseApi {
  protected async fetch<T>(method?: RequestInit['method'], request?: Request) {
    const auth_token = getSessionLsItem()?.attributes.auth_token
    return super.fetch<T>(method, {
      ...request,
      headers: {
        ...DEFAULT_HEADERS,
        ...request?.headers,
        Authorization: auth_token ? `Bearer ${auth_token}` : undefined,
      },
    })
  }
}
